import { Box, Container } from '@mui/material'
import React from 'react'
import ActivedInvestmentPlans from './ActivedInvestmentPlans'

export default function InvestDashboard() {
  return (
   <>
   <ActivedInvestmentPlans/>
   </>
  )
}
